import axios from 'axios';
import { handleRequest } from 'helpers/api';

const USER_URL = `${process.env.REACT_APP_API_URL}/cart`;

const userApi = axios.create({
  baseURL: USER_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

interface AddToCartData {
  vendorId: string;
  product: {
    productId: string;
    variantId: string;
    price: number;
    quantity: number;
  };
}

interface UpdateCartData {
  vendorId: string;
  productId: string;
  quantity: number;
}

interface ApplyCartData {
  vendorId: string;
  code: string;
}
interface RemoveCartData {
  vendorId: string;
}

export const addToCart = async (data: AddToCartData) => {
  return handleRequest(userApi.post('/add-to-cart', data));
};

export const removeFromCart = async (
  productId: string,
  variantId: string,
  vendorId: string
) => {
  return handleRequest(
    userApi.delete(`/remove-from-cart/${vendorId}/${productId}/${variantId}`)
  );
};

export const updateCart = async (data: UpdateCartData) => {
  return handleRequest(userApi.put('/update-cart', data));
};

export const applyCouponAtCart = async (data: ApplyCartData) => {
  return handleRequest(userApi.post('/apply-coupon', data));
};

export const removeCoupon = async (data: RemoveCartData) => {
  return handleRequest(userApi.post('/remove-coupon', data));
};

export const getCart = async () => {
  return handleRequest(userApi.get('/get-cart'));
};
